import React, { useEffect, useState } from "react";
import FieldBox from "../../../utils/Form/ui/FieldBox";
import Modal from "../../../components/ui/Modal/Modal";
import QRTable from "./QRTable";
import QRListTable from "./QRListTable";
import { useLotData } from "../../../api/order-management/use-order-lot-data";
import { useAddFullShipping } from "../../../api/order-management/use-add-full-shipping";

const QRModal = (props) => {
  const {
    confirmModal,
    id,
    productData,
    onCloseQrModal,
    remainingQty,
    isExchanged,
  } = props;
  const [closeModalOption, setCloseModalOption] = useState(false);
  const [closeModalQR, setCloseModalQR] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [summedQty, setSummedQty] = useState(0);
  const { getDataTableProps } = useLotData({}, id);
  const dataQr = getDataTableProps().data;
  const { mutate: addFullShipping } = useAddFullShipping();
  const [triggerCloseQrTableModal, setTriggerCloseQrTableModal] =
    useState(false);
  const [deliveryCourier, setDeliveryCourier] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [mode, setMode] = useState("");
  const isDisabled =
    mode === "full"
      ? summedQty === 0 ||
        !summedQty ||
        summedQty !== productData?.quantity ||
        invoiceNumber === "" ||
        deliveryCourier === ""
      : summedQty === 0 ||
        !summedQty ||
        summedQty > remainingQty ||
        invoiceNumber === "" ||
        deliveryCourier === "";

  const totalQnt = dataQr?.reduce((a, b) => a + b?.qnt, 0);

  const onChangeCourier = (e) => {
    setDeliveryCourier(e.target.value);
  };

  const onChangeInvoice = (e) => {
    setInvoiceNumber(e.target.value);
  };

  useEffect(() => {
    if (triggerCloseQrTableModal === true) {
      setTriggerCloseQrTableModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerCloseQrTableModal]);

  const onCloseQrTableModal = () => {
    setTriggerCloseQrTableModal(true);
  };

  useEffect(() => {
    if (closeModalOption === true) {
      setCloseModalOption(false);
    }
  }, [closeModalOption]);

  useEffect(() => {
    if (closeModalQR === true) {
      setCloseModalQR(false);
    }
  }, [closeModalQR]);

  const handleFullShipping = () => {
    setMode("full");
    setCloseModalOption(true);
    setCloseModalQR(true);
    setSelectedData(
      dataQr
        ?.filter((res) =>
          selectedItem?.some((val) => val.productLotId === res?.id)
        )
        ?.map((res) => res)
    );
  };
  const handlePartialShipping = () => {
    setMode("partial");
    setCloseModalOption(true);
    setCloseModalQR(true);
    setSelectedData(
      dataQr
        ?.filter((res) =>
          selectedItem?.some((val) => val.productLotId === res?.id)
        )
        ?.map((res) => res)
    );
  };

  const onSelectLot = (id) => {
    const index = selectedItem.indexOf(id);
    if (selectedItem.some((e) => e.productLotId === id)) {
      selectedItem.splice(index, 1);
      setSelectedItem([...selectedItem]);
    } else {
      setSelectedItem([...selectedItem, { productLotId: id, qnt: 0 }]);
    }
  };

  const handleChangeItem = (e, id, nameForm) => {
    const objIndex = selectedItem.findIndex((res) => res.productLotId === id);
    const val = e.target.value;
    if (!val) {
      selectedItem[objIndex][nameForm] = 0;
    } else {
      selectedItem[objIndex][nameForm] = parseInt(e.target.value);
    }
    const summed = selectedItem?.reduce((a, b) => a + parseInt(b.qnt), 0);
    setSummedQty(summed);
  };

  const handleSubmit = async () => {
    const payload = {
      deliveryCompanyName: deliveryCourier,
      invoiceNo: invoiceNumber,
      productOrderId: productData?.productOrderId,
      details: selectedItem,
      isExchanged: isExchanged ? true : false,
    };
    await addFullShipping(payload);
  };

  return (
    <div>
      <div className="flex items-center pb-2 pt-1 border-b justify-between">
        <p className="font-bold px-4 text-sm">배송 출고처리</p>
        <div className="flex px-4">
          <Modal
            description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
            onSubmit={onCloseQrModal}
          >
            <button
              type="button"
              className="w-20 rounded-[4px] border-button-grey text-black py-1 mr-2 border"
            >
              취소
            </button>
          </Modal>
          <Modal
            maxWidth="max-w-[26rem]"
            description={
              <span>
                입력하신 정보로 진행하시겠습니까? <br />
                출고처리를 할 경우, 자동으로 재고가 차감되고 송장번호는 고객에게
                <br />
                바로 연동됩니다. 정확히 출고수량과 송장번호를 입력했는지 확인해
                주세요.
              </span>
            }
            onSubmit={handleSubmit}
          >
            <button
              type="button"
              disabled={isDisabled}
              className={`w-20 rounded-[4px] py-1 ${
                isDisabled
                  ? "text-disable-black bg-input-grey border"
                  : "text-white bg-primary-blue"
              }`}
            >
              등록 완료
            </button>
          </Modal>
        </div>
      </div>
      <div className="border mt-4 py-2 mx-4 px-3 border-primary-blue text-white bg-primary-blue">
        상품정보
      </div>
      <div className="flex px-4 items-center">
        <div className="w-1/2">
          <FieldBox splitted label="카테고리">
            <span className="p-2">
              {productData?.product?.productGroup?.productGroupCategory?.name}
            </span>
          </FieldBox>
        </div>
        <div className="w-1/2">
          <FieldBox splitted label="REF(상품코드)">
            <span className="p-2">{productData?.ref}</span>
          </FieldBox>
        </div>
      </div>
      <div className="px-4">
        <FieldBox isLast label="상품명">
          <span className="p-2">{productData?.productName}</span>
        </FieldBox>
      </div>
      <div className="px-4">
        <Modal
          hasCancel={false}
          hasSubmit={false}
          triggerClose={closeModalQR}
          padding="p-0"
          description={
            <div className="space-y-1 px-4 pt-2">
              <p className="text-secondary-red">QR 스캔이 활성화 되었습니다.</p>
              <p>1. 바코드 리더기로 해당 상품을 스캔해주세요.</p>
              <p>2. 일치하는 상품이 있는 경우, QR 스캔 결과가 나옵니다.</p>
              <div className="pt-4 flex justify-end">
                <Modal
                  hasCancel={false}
                  hasSubmit={false}
                  maxWidth="max-w-[47rem]"
                  padding="p-0"
                  description={
                    <QRTable
                      mode={mode}
                      handlePartialShipping={handlePartialShipping}
                      confirmModal={confirmModal}
                      handleFullShipping={handleFullShipping}
                      closeModal={closeModalOption}
                      dataQr={dataQr}
                      selectedItem={selectedItem}
                      onSelectLot={onSelectLot}
                      onCloseQrTableModal={onCloseQrTableModal}
                      totalQnt={totalQnt}
                      isExchanged={isExchanged}
                    />
                  }
                  triggerClose={triggerCloseQrTableModal}
                >
                  <button className="border rounded-[4px] border-primary-blue bg-primary-blue text-white px-4 py-1">
                    QR 스캔 닫기
                  </button>
                </Modal>
              </div>
            </div>
          }
        >
          <button className="w-full py-2 font-bold rounded-[4px] bg-drop-yellow mt-4">
            QR 스캔
          </button>
        </Modal>
      </div>

      <div className="border-8 mt-6 border-r-0 border-l-0">
        {selectedData?.length === 0 ? (
          <div className="text-center">
            <p className="text-title-grey my-28">
              출고 상품의 QR을 스캔해주세요.
            </p>
          </div>
        ) : (
          <QRListTable
            mode={mode}
            selectedItem={selectedItem}
            totalData={selectedData.length}
            selectedData={selectedData}
            productData={productData}
            handleChangeItem={handleChangeItem}
            summedQty={summedQty}
            remainingQty={remainingQty}
            totalQnt={totalQnt}
          />
        )}
      </div>

      <div className="px-4 mt-4">
        {selectedData?.length > 0 ? (
          <>
            <p className="font-bold">운송장 정보</p>
            <div className="flex mt-2 items-center">
              <div className="w-1/2">
                <FieldBox splitted isLast label="택배사 정보">
                  <input
                    value={deliveryCourier}
                    type="text"
                    placeholder="택배기사를 입력해주세요."
                    className="outline-none placeholder:text-[#767676]"
                    onChange={onChangeCourier}
                  />
                </FieldBox>
              </div>
              <div className="w-1/2">
                <FieldBox splitted isLast label="송장번호 입력">
                  <input
                    value={invoiceNumber}
                    onChange={onChangeInvoice}
                    type="text"
                    placeholder="송장번호를 정확히 입력해주세요."
                    className="outline-none placeholder:text-[#767676]"
                  />
                </FieldBox>
              </div>
            </div>
          </>
        ) : (
          <div className="h-16"></div>
        )}
      </div>
    </div>
  );
};

export default QRModal;
